import React, {Component} from 'react';
import Modal from '@homeaway/react-modal';
import LandingPage from '../../../components/onboarding/landing-page/landing-page';
import {compose} from 'redux';
import {withAuth} from '../../../components/auth';
import {withTranslationsAsProps} from '../../../components/translations';
import {modalSeen, modalClosed, modalError} from '../edap';

export class CreateTripboardModal extends Component {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.handleError = this.handleError.bind(this);
    }

    componentDidMount() {
        if (this.props.isOpen) {
            modalSeen();
        }
    }

    componentDidUpdate(prevProps) {
        const {isOpen} = this.props;
        const {isOpen: wasOpen} = prevProps;
        if (isOpen && !wasOpen) {
            modalSeen();
        }
    }

    handleClose() {
        modalClosed();
        const {handleModalClose} = this.props;
        handleModalClose();
    }

    handleError() {
        modalError();
        const {handleModalClose} = this.props;
        handleModalClose();
    }

    render() {
        const {hav, isOpen, title} = this.props;
        return (
            <Modal id="create-tripboard__modal" onClose={this.handleClose} isOpen={isOpen} isWorkflow title={title}>
                <LandingPage hav={hav} onError={this.handleError} onDone={this.handleClose} modalLayout />
            </Modal>
        );
    }
}

export default compose(withAuth, withTranslationsAsProps({'tripboards.modal.create.new.list.copy': 'title'}))(
    CreateTripboardModal
);



// WEBPACK FOOTER //
// ./src/universal/tripboard/create-tripboard-controls/components/create-tripboard-modal.js